import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const APPSFLYER_DOMAIN = "appsflyer";
export const SEND_EVENT = "event/send";

export const appsflyerApi = {
  sendEvent: (eventName: string) =>
    axiosInstance.post<CustomResponseFormat>(
      `${APPSFLYER_DOMAIN}/${SEND_EVENT}`,
      { eventName: eventName }
    ),
};